import { render, staticRenderFns } from "./layer-page.vue?vue&type=template&id=7b7406b2&scoped=true&"
import script from "./layer-page.vue?vue&type=script&lang=js&"
export * from "./layer-page.vue?vue&type=script&lang=js&"
import style0 from "./layer-page.vue?vue&type=style&index=0&id=7b7406b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7406b2",
  null
  
)

export default component.exports